import { mapState, mapMutations } from "vuex";
import { conversion } from "@/tool";
import * as apis from "@/api";
import Award3 from "@/components/award3";
import Cookies from "@/utils/cookie";

const LIST_TYPE_TABS = [
  { label: "所有", value: "" },
  { label: "最新", value: 1 },
  { label: "对多人开", value: 7 },
];

const PRICE_RANGES = [
  { label: "所有", value: "all", min: 0, max: 99999999 },
  { label: "0-1", value: "01", min: 0, max: 1 },
  { label: "2-19", value: "219", min: 2, max: 19 },
  { label: "20-49", value: "2049", min: 20, max: 49 },
  { label: "50-99", value: "5099", min: 50, max: 99 },
  { label: "100+", value: "100", min: 100, max: 999999 },
];

const PRICE_SORTS = [
  { label: "默认", value: "default" },
  { label: "价格降序", value: "desc" },
  { label: "价格升序", value: "asc" },
];

const SORT_RANGES = [
  { label: "默认", value: "default" },
  { label: "最新", value: "newest" },
  { label: "最热", value: "hot" },
];

const RISK_LIST = [
  { name: "L", value: "l", activeBg: "rgb(56, 199, 57)", riskSchedule: 12.5 },
  { name: "M", value: "m", activeBg: "rgb(247, 188, 59)", riskSchedule: 37.5 },
  { name: "H", value: "h", activeBg: "rgb(251, 126, 61)", riskSchedule: 61.5 },
  { name: "I", value: "i", activeBg: "rgb(255, 64, 64)", riskSchedule: 87.5 },
];

function isSuccess(res) {
  const data = res && res.data;
  return !!(data && (data.code === 0 || data.success));
}

function riskIndex(item) {
  const level = item && item.riskLevel != null ? Number(item.riskLevel) : 1;
  return Math.min(3, Math.max(0, Number.isNaN(level) ? 1 : level));
}

export default {
  components: {
    "c-award": Award3,
  },
  filters: {
    conversion,
  },
  data() {
    return {
      activeTab: "",
      listTypeTabs: LIST_TYPE_TABS,
      priceRangeValue: "all",
      priceSortValue: "default",
      sortRangeValue: "default",
      priceRangeList: PRICE_RANGES,
      priceSortList: PRICE_SORTS,
      sortRangeList: SORT_RANGES,
      riskList: RISK_LIST,
      boxList: [],
      listData: null,
      currentUserInfo: null,
      currentUserCheckId: 0,
      profitInfo: null,
      profitInfoLoading: false,
      bioEditModalVisible: false,
      bioEditValue: "",
      bioEditLoading: false,
      shareModalVisible: false,
      listLoading: false,
      loadMoreLoading: false,
      listPage: 1,
      listPageSize: 20,
      listTotal: 0,
    };
  },
  computed: {
    ...mapState(["user"]),
    memberIdFromRoute() {
      const query = (this.$route && this.$route.query) || {};
      const id = query.memberId != null ? query.memberId : query.id;
      return id != null && id !== "" ? String(id).trim() : "";
    },
    shareUrl() {
      const baseUrl = typeof window === "undefined" ? "" : window.location.origin;
      return baseUrl && this.memberIdFromRoute
        ? `${baseUrl}/box/share?id=${encodeURIComponent(this.memberIdFromRoute)}`
        : `${baseUrl}/box/share`;
    },
    shareTitle() {
      return `${this.userProfile.nickname || "Ta"}邀请你来开他创建的箱子!`;
    },
    currentUserId() {
      const user = this.currentUserInfo || {};
      return user.uid || user.id || user.memberId || user.userId || "";
    },
    isCurrentUserShare() {
      return !!this.currentUserId && String(this.memberIdFromRoute) === String(this.currentUserId);
    },
    userProfile() {
      const data = this.listData || {};
      const user = this.isCurrentUserShare ? this.currentUserInfo || this.user || {} : {};
      return {
        avatar: data.creatorAvatar || user.avatar || user.headImgUrl || "",
        nickname: data.creatorName || user.nickname || user.userName || "",
        uid: data.creatorId || user.uid || user.id || "",
        intro: data.creatorBio || user.bio || user.intro || user.signature || "",
        level: user.level,
      };
    },
    userStats() {
      return {
        createdCount: this.listTotal,
        openedValue: this.boxList.reduce((sum, item) => sum + Number(item.totalProfit || 0), 0),
      };
    },
    displayEarnings() {
      return this.profitInfo && this.profitInfo.pendingProfit != null ? this.profitInfo.pendingProfit : 0;
    },
    profitInfoStats() {
      const info = this.profitInfo || {};
      return {
        totalCaseCount: info.totalCaseCount || 0,
        totalOpenedValue: info.totalOpenedValue || 0,
        totalReceivedProfit: info.totalReceivedProfit || 0,
        todayOpenCount: info.todayOpenCount || 0,
        todayOpenedValue: info.todayOpenedValue || 0,
        todayProfit: info.todayProfit || 0,
        pendingProfit: info.pendingProfit || 0,
      };
    },
    displayList() {
      let list = this.boxList.slice();
      const range = this.priceRangeList.find((item) => item.value === this.priceRangeValue);

      if (range && range.value !== "all") {
        list = list.filter((item) => item.price >= range.min && item.price <= range.max);
      }
      if (this.priceSortValue === "desc") {
        list.sort((a, b) => (b.price || 0) - (a.price || 0));
      }
      if (this.priceSortValue === "asc") {
        list.sort((a, b) => (a.price || 0) - (b.price || 0));
      }

      return list;
    },
    hasMore() {
      return this.boxList.length < this.listTotal && !this.listLoading;
    },
    listType() {
      const type = this.activeTab;
      return type >= 1 && type <= 6 ? type : 1;
    },
  },
  watch: {
    activeTab() {
      this.reloadCases();
    },
    memberIdFromRoute: {
      immediate: true,
      handler() {
        this.reloadCases();
        this.checkCurrentUserShare();
      },
    },
  },
  methods: {
    ...mapMutations(["setInfo"]),
    resetCases() {
      this.boxList = [];
      this.listData = null;
      this.listPage = 1;
      this.listTotal = 0;
    },
    reloadCases() {
      this.resetCases();
      if (this.memberIdFromRoute) this.loadCases(1);
    },
    getUserId(user) {
      return user && (user.uid || user.id || user.memberId || user.userId || "");
    },
    async checkCurrentUserShare() {
      const checkId = this.currentUserCheckId + 1;
      const memberId = this.memberIdFromRoute;
      this.currentUserCheckId = checkId;
      this.currentUserInfo = null;
      this.profitInfo = null;

      if (!memberId || !Cookies.getToken() || !apis.userInfo) return;

      try {
        const res = await apis.userInfo();
        if (checkId !== this.currentUserCheckId || memberId !== this.memberIdFromRoute) return;

        const user = isSuccess(res) ? res.data.data || null : null;
        if (!user || String(this.getUserId(user)) !== String(memberId)) return;

        this.currentUserInfo = user;
        this.loadProfitInfo();
      } catch (error) {
        if (checkId === this.currentUserCheckId) {
          this.currentUserInfo = null;
          this.profitInfo = null;
        }
      }
    },
    async loadProfitInfo() {
      if (!this.isCurrentUserShare || !apis.getProfitInfo || this.profitInfoLoading) return;
      this.profitInfoLoading = true;
      try {
        const res = await apis.getProfitInfo();
        this.profitInfo = isSuccess(res) ? res.data.data || null : null;
      } catch (error) {
        console.warn("getProfitInfo error", error);
        this.profitInfo = null;
      } finally {
        this.profitInfoLoading = false;
      }
    },
    async handleClaimEarnings() {
      if (!this.isCurrentUserShare) return;
      if (!this.profitInfo || this.profitInfo.pendingProfit == null || this.profitInfo.pendingProfit <= 0) {
        this.$message && this.$message.warning("暂无待领取收益");
        return;
      }

      try {
        const res = await apis.withdrawProfit();
        if (isSuccess(res)) {
          this.$message && this.$message.success("收益领取成功");
          await this.loadProfitInfo();
          this.setInfo();
        } else {
          const errorMsg = (res && res.data && res.data.msg) || "领取失败，请重试";
          this.$message && this.$message.error(errorMsg);
        }
      } catch (error) {
        console.warn("withdrawProfit error", error);
        this.$message && this.$message.error("领取失败，请重试");
      }
    },
    openBioEditModal() {
      if (!this.isCurrentUserShare) return;
      this.bioEditValue = this.userProfile.intro || "";
      this.bioEditModalVisible = true;
    },
    closeBioEditModal() {
      this.bioEditModalVisible = false;
      this.bioEditValue = "";
    },
    async saveBio() {
      if (!this.isCurrentUserShare || this.bioEditLoading) return;

      this.bioEditLoading = true;
      try {
        const res = await apis.setBio({ val: this.bioEditValue });
        if (isSuccess(res)) {
          if (this.currentUserInfo) {
            this.currentUserInfo = {
              ...this.currentUserInfo,
              bio: this.bioEditValue,
              intro: this.bioEditValue,
              signature: this.bioEditValue,
            };
          }
          if (this.listData) {
            this.listData = {
              ...this.listData,
              creatorBio: this.bioEditValue,
            };
          }

          this.setInfo();
          this.$message && this.$message.success("简介更新成功,请等待审核");
          this.closeBioEditModal();
        } else {
          const errorMsg = (res && res.data && res.data.msg) || "保存失败，请重试";
          this.$message && this.$message.error(errorMsg);
        }
      } catch (error) {
        console.warn("setBio error", error);
        this.$message && this.$message.error("保存失败，请重试");
      } finally {
        this.bioEditLoading = false;
      }
    },
    async loadCases(page) {
      if (!this.memberIdFromRoute || !apis.getUserCasesByMemberId) return;

      const isFirstPage = page === 1;
      this[isFirstPage ? "listLoading" : "loadMoreLoading"] = true;
      try {
        const res = await apis.getUserCasesByMemberId(this.memberIdFromRoute, {
          type: this.listType,
          page,
          pageSize: this.listPageSize,
        });
        const data = isSuccess(res) ? res.data.data || {} : {};
        const list = data.list || [];

        if (isFirstPage) this.listData = data;
        this.boxList = isFirstPage ? list : this.boxList.concat(list);
        this.listPage = page;
        this.listTotal = data.total != null ? data.total : this.boxList.length;
      } catch (error) {
        console.warn(isFirstPage ? "getUserCasesByMemberId error" : "getUserCasesByMemberId loadMore error", error);
        if (isFirstPage) this.resetCases();
      } finally {
        this[isFirstPage ? "listLoading" : "loadMoreLoading"] = false;
      }
    },
    loadMore() {
      if (!this.loadMoreLoading && this.hasMore) {
        return this.loadCases(this.listPage + 1);
      }
    },
    itemRiskLevel(item) {
      const risk = this.riskList[riskIndex(item)];
      return risk ? risk.value : "m";
    },
    itemRiskSchedule(item) {
      const risk = this.riskList[riskIndex(item)];
      return risk ? risk.riskSchedule : 37.5;
    },
    awardSections(item) {
      return [
        { title: "包含物品", list: item.items || [] },
        { title: "最近掉落", list: item.recentDrops || [] },
      ];
    },
    onShare() {
      this.shareModalVisible = true;
    },
    closeShareModal() {
      this.shareModalVisible = false;
    },
    async copyShareUrl() {
      if (!this.shareUrl) return;

      const desc = this.$refs.shareDescP
        ? this.$refs.shareDescP.innerText || this.$refs.shareDescP.textContent
        : "快来看看我的箱子~";
      const copyText = `${String(desc || "").trim()} ${this.shareUrl}`;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(copyText);
        } else {
          const input = document.createElement("input");
          input.value = copyText;
          input.readOnly = true;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$toast && this.$toast.success("已复制网址");
      } catch (error) {
        this.$toast && this.$toast.fail("复制失败");
      }
    },
    goOpen(item) {
      if (!item.id) return;
      this.$router.push({
        name: "case",
        params: { id: item.id },
        query: { userCase: 1 },
      });
    },
    scrollAwardList(event, direction) {
      const wrap =
        event &&
        event.currentTarget &&
        event.currentTarget.closest &&
        event.currentTarget.closest(".mine-card-award-list-wrap");
      const list = wrap && wrap.querySelector(".mine-card-award-list");
      if (list) list.scrollBy({ left: direction * 220, behavior: "smooth" });
    },
  },
};
